import {JsonPageable, JsonSort} from 'rueb-data-model';

export class DataPage<T> {
  content: T[];
  pageable: JsonPageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  number: number;
  sort: JsonSort;
  size: number;
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}
